import React from "react";
import {
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Text,
	Link,
} from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";

const PrivateEquityPulse: React.FC = () => (
	<>
		{/* members */}
		<Flex
			as="section"
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height={{ xs: "450px", sm: "300px" }}
			minH={{ xs: "450px", sm: "300px" }}
			maxH="450px"
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/jpg/blogBanner.jpg"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDir="column"
				px={{ xs: "20px", sm: "28px", md: "45px", lg: "60px", xl: "inherit" }}
			>
				<Heading
					as="h1"
					mb="20px"
					variant="reportCardTitle"
					fontSize={{ xs: "26px", sm: "28px", md: "32px", lg: "38px" }}
					color="white"
					lineHeight={{ xs: "34px", md: "39px", lg: "42px" }}
				>
					Crossover IV Fund by Nuvama: Aiming for Rs 4,000 Crore with Strategic
					Middle Eastern Outreach
				</Heading>
			</Container>
		</Flex>
		<Container
			as="section"
			maxW="container.xl"
			pb="80px"
			pt="40px"
			minH="420px"
			display={{ xs: "flex", md: "inherit" }}
			flexDirection="column"
		>
			<Box as="main" w="100%" pb="40px">
				<Text variant="blogAnswer">
					Spokesperson: Anshu Kapoor, President and Head, Nuvama Asset
					Management
					<Link
						href="https://www.linkedin.com/in/anshukapoor/?originalSubdomain=in&original_referer=https%3A%2F%2Fwww.google.com%2F"
						target="_blank"
						style={{
							textDecoration: "underline",
						}}
						rel="noreferrer"
					>
						{" "}
						Anshu Kapoor
					</Link>
					, Partner,{" "}
					<Link
						href="https://www.nuvama.com/"
						target="_blank"
						style={{
							textDecoration: "underline",
						}}
						rel="noreferrer"
					>
						Nuvama Group
					</Link>
					. In this feature he shares the venture fund’s vision to back high
					value start-ups who are “building from India for the world”, the close
					of its $129Mn cloud fund, top investment trends and the fund’s bullish
					approach towards investing in enterprise centric sectors in 2023.
				</Text>
			</Box>

			<Img
				src="https://static.levocdn.com/WGLBUT82/AnshuKapoor1-mox83bQqsVeX.jpg"
				alt="Anshu Kapoor"
				width="300px"
				float={{ xs: "right", md: "left" }}
				alignSelf={{ xs: "center", md: "flex-start" }}
				mx={{ xs: "0px", md: "0px" }}
				mr={{ xs: "0px", md: "40px", lg: "60px", xl: "70px" }}
				mb="20px"
				objectFit="contain"
			/>
			<Box>
				<Link
					display="flex"
					alignItems="center"
					href="https://www.linkedin.com/in/anshukapoor/?originalSubdomain=in&original_referer=https%3A%2F%2Fwww.google.com%2F"
					target="_blank"
				>
					<IconButton
						aria-label="linkedin"
						icon={<FaLinkedin size="28px" color="rgba(100, 100, 140, 0.6)" />}
						variant="unstyled"
						cursor="pointer"
					/>
					<Heading
						fontWeight="800"
						variant="blogQuestion"
						fontSize="20px"
						opacity="0.8"
					>
						Anshu Kapoor
					</Heading>
				</Link>
				<Box
					ml={{ xs: "auto", md: "345px", lg: "370px" }}
					mr={{ xs: "auto", md: "0px" }}
					width={{ xs: "160px", md: "80px" }}
					h="2px"
					bgColor="primary.500"
					borderRadius="5px"
					mt={{ xs: "16px", md: "10px" }}
					mb="15px"
				/>
				<Box mt="16px" mb="20px">
					<Text variant="blogAnswer">
						Delve into the strategic realm of growth equity with IVCA’s Private
						Equity Pulse. Today we speak to Anshu Kapoor, President and Head,
						Nuvama Asset Management. In this interview Anshu talks about Nuvama
						launching its latest Crossover IV fund, targeting Rs 4,000 crore
						with a strategic focus on wealthy individuals in the Middle East.
						Leveraging its 25+ years of India expertise and the backing of PAG,
						Nuvama aims to attract high-net-worth individuals, NRIs, and family
						offices in the GCC region. The fund will invest in companies
						preparing to go public, offering a unique buy private, sell public
						approach for superior risk-adjusted returns. This move marks
						Nuvama&apos;s first major venture into offshore markets, aligning
						with its goal to expand and diversify its investor base.
					</Text>
				</Box>
				{/* Question 2 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pb="20px" pt="12px">
						1. Nuvama Asset Management is targeting Rs 4,000 crore for its
						latest Nuvama Crossover IV fund, with a significant focus on tapping
						wealthy individuals in the Middle East. Can you elaborate on the
						strategy behind targeting this specific investor segment and how it
						aligns with Nuvama&apos;s overall investment approach?
					</Heading>

					<Text variant="blogAnswer" pt="8px">
						Nuvama is a trusted brand amongst domestic investors with a legacy
						of India expertise built over the last 25+ years. With the backing
						of a renowned global name like PAG, Nuvama Asset Management has a
						clear focus on offering alternative solutions around asset classes
						such as private equity, public markets, and real assets. The
						Crossover Funds platform is the flagship offering under the private
						equity vertical, first launched in 2017. With a market-leading
						performance, the maiden series of this fund has returned the entire
						capital and gains to investors – one of the few in its vintage to do
						so. We have raised ~US$ 800 million across our all-Private Equity
						strategies till date.
						<br />
						<br />
						As India’s Private Equity ecosystem evolves, we see a strong demand
						picking up across regions. We are excited to venture into the
						offshore markets starting with GCC as the first step. Along with the
						proximity, below are some of the factors that make GCC a key region
						for us:
						<br />
						<br />
						<Flex flexDirection="column" gap="14px">
							<Text>
								<span
									style={{
										fontWeight: "bold",
										marginRight: "4px",
									}}
								>
									a) Wealth Concentration:
								</span>
								The Middle East, particularly countries like the United Arab
								Emirates, Saudi Arabia, and Qatar, boasts a significant
								concentration of high-net-worth individuals and
								ultra-high-net-worth individuals. Along with the Individual
								investors, GCC regions have few of the largest wealth funds and
								family offices which have been actively investing in India
								Private Equity over the last few years.
							</Text>
							<Text>
								<span
									style={{
										fontWeight: "bold",
										marginRight: "4px",
									}}
								>
									b) NRI Base:
								</span>
								Over 60% of NRIs are based out of GCC countries. With deep ties
								to their homeland, this large Indian diaspora is keenly
								interested in participating in India&apos;s rising wealth
								generation opportunities.
							</Text>
							<Text>
								<span
									style={{
										fontWeight: "bold",
										marginRight: "4px",
									}}
								>
									c) Need for Geographical Diversification:
								</span>
								The 4 key Ingredients of success: Deep pools of labour,
								Competitive Cost structures, Capabilities across industries and
								growing exports make India a premier destination in the backdrop
								of China Plus One policy.
							</Text>
							<Text>
								<span
									style={{
										fontWeight: "bold",
										marginRight: "4px",
									}}
								>
									d) Strategic Partnerships:
								</span>
								Establishing relationships with wealthy individuals in the
								Middle East can go beyond mere capital infusion. It can lead to
								strategic partnerships, co-investment opportunities, and access
								to valuable networks and resources within the region. These
								partnerships can enhance deal sourcing, due diligence
								capabilities, and post-investment value creation initiatives,
								ultimately contributing to the success of the Nuvama Asset
								Management franchise.
							</Text>
							<Text>
								<span
									style={{
										fontWeight: "bold",
										marginRight: "4px",
									}}
								>
									e) Alignment with Investment Approach:
								</span>
								Nuvama&apos;s investment approach emphasizes on investing in
								high-potential companies positioned for significant growth and
								value creation. Such companies are often found in sectors
								undergoing rapid technological innovation, disruption, or
								transformation, areas where Middle Eastern investors see
								substantial upside potential. With an alignment of investment
								preferences and risk appetite of individuals/Institutions in the
								region, a focus on this region enables Nuvama to attract capital
								from investors who share its vision and strategic objectives.
							</Text>
						</Flex>
					</Text>
				</Box>

				{/* Question 3 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="28px">
						2. Could you provide insights into the investment thesis of Nuvama
						Crossover IV fund, which focuses on investing in companies preparing
						to go public on Indian stock exchanges? How does Nuvama identify and
						evaluate potential investment opportunities within this space?
					</Heading>
					<Text variant="blogAnswer" mt="16px" mb="8px">
						Nuvama Crossover Fund partners with companies in a crucial phase of
						the company – the crossover phase. In the crossover phase, the
						company “crosses over” from the being a Privately held company to a
						publicly listed enterprise. This is a pivotal phase for all the key
						stakeholders of the company – For the Promotors/parent, for previous
						PE investors, for the company.
						<br />
						<br />
						The “buy Private - sell Public” is a proven approach that offers a
						better risk adjusted returns profile. We are looking for companies
						with an intent and a plan to go public in ~2-3 years from our
						investment date. These evolved enterprises have proven business
						economics and an ability to continue high growth for the long term.
						Demonstrated track record and an established, meaningful scale
						results in a significantly lower mortality rate. This “Crossover”
						style of investing is one of the best strategies for PE investing as
						it offers a superior risk-reward profile.
						<br />
						<br />
						Our sector agnostic investment framework has been meticulously
						crafted and perfected through years of hands-on experience by an
						able Fund management team. The value investment framework is based
						on 3 pillars –
						<br />
						<br />
						<Flex flexDirection="column" gap="14px">
							<Text>
								<span
									style={{
										fontWeight: "bold",
										marginRight: "4px",
									}}
								>
									a) Thematic bias:
								</span>
								Growing sectors driven by structural Indian underpenetrated
								consumer growth. Large market potential, Visible room for
								structural growth over at least 5+ years.
							</Text>
							<Text>
								<span
									style={{
										fontWeight: "bold",
										marginRight: "4px",
									}}
								>
									b) Leadership bias:
								</span>
								Capabilities as a market leader or path to leadership, Higher
								growth than industry (increasing market share).
							</Text>
							<Text>
								<span
									style={{
										fontWeight: "bold",
										marginRight: "4px",
									}}
								>
									c) Fundamental bias:
								</span>
								Higher growth in revenues and profitability compared to peers
								and industry, Proven unit economics with a capital efficient
								business model, Low or no leverage and low susceptibility to
								market shocks.
							</Text>
						</Flex>
					</Text>
				</Box>

				{/* Question 4 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						3. Nuvama also plans to raise capital for a new public equities
						long-short product. What are the key objectives and strategies of
						this product?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						Nuvama Asset Management’s public equities arm is built around
						offering alternative solutions designed to tap into opportunities
						presented by India’s vibrant public markets. EDGE (Enhanced Dynamic
						Growth Equity) Fund is the Long-short strategy that is an
						alternative for large cap equity. The objective of this strategy is
						to deliver returns while lowering the portfolio volatility. EDGE
						fund is a category leader in India in terms of performance.
					</Text>
				</Box>
				{/* Question 5 */}

				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						4. The decision to register both funds in Gujarat International
						Finance Tec-City (GIFT City) reflects a strategic move. Could you
						discuss the advantages of operating from GIFT City and how it
						enhances Nuvama&apos;s capabilities in fund management and investor
						relations?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						GIFT IFSC is built with the idea of being India’s gateway to inbound
						and outbound investments.
						<br />
						<br />
						All three routes of investments in India – FDI, FPI and FVCI are
						available to IFSC entities. This flexibility under the foreign
						exchange regulations complements AIF regulations well, making IFSC
						attractive for a wide range of funds.
						<br />
						<br />
						Parity with international jurisdictions, favorable taxation regime,
						calibrated regulatory regime are among the key factors that have led
						to gaining international investor’s trust as the preferred
						investment route
					</Text>
				</Box>
				{/* Question 6 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						5. Anshu Kapoor mentioned expectations for Nuvama&apos;s assets
						under management to grow significantly in the next 12 to 18 months.
						What factors are driving this projected growth, and what are the key
						initiatives Nuvama is undertaking to achieve its growth targets?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						Nuvama Asset Management manages ~US$ 1 billion of assets under
						various strategies. As we build a strong track record and
						distribution strength, we expect the assets under management to
						expand significantly in the next 4-6 quarters. Some of the key
						factors and initiatives driving this growth are:
						<br />
						<br />
						<Flex flexDirection="column" gap="14px">
							<Text>
								<span
									style={{
										fontWeight: "bold",
										marginRight: "4px",
									}}
								>
									a) Distribution network:
								</span>
								With the differentiated market leading offerings, we have been
								able to partner with ~20 prominent partners across the banking
								and wealth management space. This has added on to our capability
								to scale up existing products as we add more strategies.
							</Text>
							<Text>
								<span
									style={{
										fontWeight: "bold",
										marginRight: "4px",
									}}
								>
									b) Announcement of JV:
								</span>
								As we see the potential in an emerging asset class – Commercial
								Real Estate, we have formed a 50:50 JV with Cushman & Wakefield
								to create a fund that is designed to invest in India’s rising
								office spaces market.
							</Text>
							<Text>
								<span
									style={{
										fontWeight: "bold",
										marginRight: "4px",
									}}
								>
									c) Geographical expansion:
								</span>
								As we venture into the offshore markets starting with the GCC
								market, we expect to get foreign investors for the first time.
								This will open doors to large pools of offshore capital,
								propelling the AUM numbers for us.
							</Text>
							<Text>
								<span
									style={{
										fontWeight: "bold",
										marginRight: "4px",
									}}
								>
									d)GIFT US$ India offering:
								</span>
								We have mirrored the India strategies into their USD versions as
								we list our two flagship funds on the GIFT IFSC platform. This
								will enable us to effectively tap the NRI investor base on a
								large scale.
							</Text>
						</Flex>
					</Text>
				</Box>
				{/* Question 7 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						6. Nuvama emphasizes a client-centric approach, prioritizing the
						understanding of client dreams and aspirations. How does Nuvama
						integrate this philosophy into its investment strategies and client
						relationships?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						Nuvama Group has Assets under Advice (AUA) of ~US$ 40 billion across
						a million+ clients. At Nuvama, the client-centric approach is not
						just a slogan; it&apos;s ingrained in every aspect of our
						operations. Nuvama ecosystem offers an unmatched proximity to
						investors across categories. It helps us with deep insights around
						our clients’ needs and aspirations.
						<br />
						<br />
						At Nuvama Asset Management, our strategies are crafted with a focus
						on addressing the unmet needs of our clients. Our client
						relationships are built on trust, transparency, and ongoing
						communication.
					</Text>
				</Box>
				{/* Question 8 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						7. Technology plays a crucial role in Nuvama&apos;s operations, with
						a focus on technology-driven platforms that adapt to investment
						trends. Can you elaborate on the specific technologies or platforms
						utilized by Nuvama and how they contribute to delivering value to
						clients?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						Nuvama Asset Management takes pride in being the first asset manager
						to deliver a comprehensive digital experience from start to finish
						to our clients and partners. Our digital platform “Swift” makes it
						convenient for a Relationship manager to digitally complete the full
						application process. The portal is designed to improve communication
						efficiency with options to download account statements, FAQs etc on
						the go. We leverage the UIDAI’s Aadhar linked verification framework
						for an easy OTP based application, without any need for wet
						signatures.
						<br />
						<br />
						With our Whatsapp Chat bot, the Nuvama Asset Management suite is at
						the client’s fingertips. We continue to invest in technology to try
						and implement the best digital practices and platforms to ensure
						convenience, safety and adherence to regulatory frameworks.
					</Text>
				</Box>
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						8. With a diverse client base ranging from mass affluent to
						institutional investors, how does Nuvama ensure personalized and
						tailored solutions for each client segment while maintaining
						consistency in service quality?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						Nuvama ecosystem serves 1.2 million clients via Nuvama Wealth, 3600+
						ultra-high net worth families via Nuvama Private and India’s top
						DFIs, institutions via the institutional clients group. Apart from
						the internal Nuvama Distribution channels, the asset management
						business also has ~20 large external counterparties including
						India’s largest banks and wealth outfits.
						<br />
						<br />
						The risk appetite, understanding levels and expectations differ
						significantly across the clientele.
						<br />
						<br />
						For mass affluent clients, we prioritize accessibility and
						simplicity in our services, providing user-friendly platforms and
						personalized support. This might include offering simplified
						investment options and educational resources to empower clients in
						making informed decisions.
						<br />
						<br />
						Conversely, for institutional investors, we focus on sophisticated
						strategies and an unmatched access to superior investment
						capabilities built over the years. This could involve implementing
						complex investment strategies and providing detailed performance
						reporting to meet institutional standards.
						<br />
						<br />
						Despite these tailored approaches, Nuvama maintains consistency in
						service quality by adhering to rigorous internal standards and
						processes. We ensure that all clients receive the same level of
						professionalism, responsiveness, and attention to detail, regardless
						of their segment. Our dedicated client service teams are trained to
						uphold these standards and provide exceptional support across the
						board.
					</Text>
				</Box>
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						9. The management team at Nuvama comprises industry stalwarts with
						deep experience and expertise. How does the collective experience of
						the team influence Nuvama&apos;s investment decisions and client
						servicing practices?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						With seasoned industry veterans leading the way, Nuvama&apos;s
						management team brings a wealth of experience and expertise to the
						table. This collective knowledge profoundly influences both our
						investment decisions and client servicing practices.
						<br />
						<br />
						The advantages of the Nuvama Ecosystem become evident as the
						investment teams gain insights into the markets from various
						business leaders, each offering unique perspectives on their
						respective domains.
						<br />
						<br />
						The investment committees have cross division representations for a
						holistic view improving the risk assessment and decision-making
						abilities.
					</Text>
				</Box>
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						10. Looking ahead, what are Nuvama&apos;s strategic priorities and
						goals for the future? Are there any new initiatives or market
						segments the firm is exploring to further enhance its offerings and
						capabilities?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						At Nuvama Asset Management, our priorities are multifaceted,
						centered on establishing a high-quality, scalable franchise aimed at
						effectively addressing our clients unmet needs. Some of the key
						priorities are:
						<br />
						<br />
						<Flex flexDirection="column" gap="14px">
							<Text>
								<span
									style={{
										fontWeight: "bold",
										marginRight: "4px",
									}}
								>
									a) Significantly scale the franchise.
								</span>
							</Text>
							<Text>
								<span
									style={{
										fontWeight: "bold",
										marginRight: "4px",
									}}
								>
									b) Build a full suite of alternatives:
								</span>
								Among the ongoing public markets, private markets and real
								assets; we plan to add credit products.
							</Text>
							<Text>
								<span
									style={{
										fontWeight: "bold",
										marginRight: "4px",
									}}
								>
									c) Continue to scale public markets offerings:
								</span>
								Across product types and geographies.
							</Text>
							<Text>
								<span
									style={{
										fontWeight: "bold",
										marginRight: "4px",
									}}
								>
									d) Expand distribution
								</span>
								Nuvama Internal Channels, Domestic: Wealth managers, Banks and
								Institutions, International: Institutions and NRIs
							</Text>
						</Flex>
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" py="16px">
						<Flex flexDirection="column" gap="14px">
							<Text>
								<span
									style={{
										fontWeight: "bold",
										marginRight: "4px",
									}}
								>
									Private Equity Pulse by IVCA -
								</span>
								is your exclusive gateway to the dynamic world of Private
								Equity. Unlike traditional venture capital, growth equity
								focuses on mature companies with a proven track record, offering
								not just capital but invaluable strategic insights and
								operational expertise. Join us as we uncover the stories behind
								the success, featuring unique interviews with renowned thought
								leaders shaping the PE industry
							</Text>
						</Flex>
					</Text>
				</Box>
			</Box>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				The content in this section is curated by Team IVCA. For any feedback,
				connect with&nbsp;
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default PrivateEquityPulse;
